import PropTypes from 'prop-types';
import React from 'react';
import NextArrow from '../../Icons/NextArrow/NextArrow';
import PrevArrow from '../../Icons/PrevArrow/PrevArrow';

import FGBLabel from '../FGBLabel/FGBLabel';

import './SliderNav.scss';

export default class SliderNav extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * flattened array of menuItems that can be used generically
         * with more than 3 items
         */
        menuItems: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                url: PropTypes.string,
                isActive: PropTypes.bool,
            }).isRequired
        ),
    };

    renderMenuItem = (item, index) => {
        if (!item) {
            return null;
        }

        const { title, url, isActive } = item;
        const activeCss = isActive ? 'active' : '';

        return (
            <FGBLabel key={`pregnancy-${index}`}>
                <a href={url} className={activeCss}>
                    {title}
                </a>
            </FGBLabel>
        );
    };

    render() {
        const { menuItems } = this.props;

        const firstItem = menuItems[0];
        const lastItem = menuItems[menuItems.length - 1];

        const prevArrowCss = firstItem.url ? '' : 'inactive';
        const nextArrowCss = lastItem.url ? '' : 'inactive';

        return (
            <div className="component-Elements-SliderNav">
                <a href={firstItem.url} className={prevArrowCss}>
                    <PrevArrow />
                </a>

                <div className="menu-items">
                    {this.props.menuItems.map(this.renderMenuItem)}
                </div>

                <a href={lastItem.url} className={nextArrowCss}>
                    <NextArrow />
                </a>
            </div>
        );
    }
}
